<template>
  <vs-input
    class="search-input"
    color="#2D9CDB"
    v-model="searchInput"
    :placeholder="placeholder"
    @keypress.prevent.enter.exact="enableSubmit"
    @keyup.prevent.enter.exact="submit"
    icon="search"
    ref="searchInput"
  >
  </vs-input>
</template>

<script>
export default {
  data() {
    return {
      searchInput: null,
    };
  },
  props: {
    placeholder: {
      type: String,
    },
    onInputEnter: {
      type: Function,
    },
    onInput: {
      type: Function,
      required: false,
      default: null,
    },
  },
  watch: {
    searchInput() {
      if (this.onInput) {
        this.onInput(this.searchInput);
      }
    },
  },
  methods: {
    searchInputEnter() {
      document.getElementsByTagName("input")[0].blur();
      this.onInputEnter(this.searchInput);
    },
    enableSubmit() {
      this.canSubmitSearch = true;
    },
    submit() {
      if (!this.canSubmitSearch) return;
      this.searchInputEnter();
      this.canSubmitSearch = false;
    },
  },
};
</script>

<style lang="scss">
.search-input {
  input {
    height: 39px;
  }
  .vs-input--icon {
    top: 11px !important;
  }
  .vs-input--input {
    border-radius: 6px;
  }
}
</style>
